//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        budget: {
            type: [Number, String],
            default: 0.00
        }
    },
    data: function data() {
        return {
            items: {},
            empty: 1,
            loading: 1,
            data: {
                total: '0'
            }
        };
    },
    created: function created() {
        var _this = this;

        App.event.listen('cart.data.loaded', function (response) {
            _this.items = response.items;
            _this.data = response.data;

            if (_this.items.length > 0) {
                _this.empty = 0;
            } else {
                _this.empty = 1;
            }
            _this.loading = 0;
        });

        App.event.listen('cart.updated', function (response) {
            _this.items = response.items;
            _this.data = response.data;

            if (_this.items.length > 0) {
                _this.empty = 0;
            } else {
                _this.empty = 1;
            }
        });
    },


    computed: {
        url: function url() {
            return App.url + '/cart';
        },
        total: function total() {
            var total = parseInt(this.data.fullPrice);
            return total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },
        budgetAvalible: function budgetAvalible() {
            var total = parseInt(this.budget - this.data.fullPrice);
            return total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        }
    }

};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}],"syntax-dynamic-import"]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/templates/semperit/assets/js/modules/cart-small/components/CartSmall.vue
// module id = UsUX
// module chunks = 4